import { Step } from "react-joyride"
import {
     TUTORIAL_TARGET_MENU_ITEM_PROFILE,
     TUTORIAL_TARGET_PROFIL_DOCS_PERSO,
     TUTORIAL_TARGET_PROFIL_DOCS_PRO,
     TUTORIAL_TARGET_PROFIL_EDIT_INFO_PERSO,
     TUTORIAL_TARGET_PROFIL_TAB_DOCS,
     TUTORIAL_TARGET_PROFIL_TAB_INFO_PERSO,
     TUTORIAL_TARGET_PROFIL_TAB_SETTINGS,
} from "../targets/profile"

export const TUTORIAL_PROFILE_STEPS: Step[] = [
     {
          target: `.${TUTORIAL_TARGET_MENU_ITEM_PROFILE}`,
          title: "Mon profil",
          content: "Toutes vos informations et documents personnels et professionnels sont accessibles via cet élément du menu.",
          disableBeacon: true,
          placement: "right",
     },
     {
          target: `.${TUTORIAL_TARGET_PROFIL_TAB_INFO_PERSO}`,
          title: "Informations personnelles",
          content: "Vos informations personnelles sont accessibles via cet onglet.",
          disableBeacon: true,
     },
     {
          target: `.${TUTORIAL_TARGET_PROFIL_EDIT_INFO_PERSO}`,
          title: "Informations personnelles",
          content: "N'oubliez pas de changer vos informations si besoin, cela permettra au siège d'avoir vos informations à jour",
          disableBeacon: true,
     },
     {
          target: `.${TUTORIAL_TARGET_PROFIL_TAB_DOCS}`,
          title: "Documents",
          content: "Accédez et modifiez vos documents personnels et professionnels via cet onglet.",
          disableBeacon: true,
     },
     {
          target: `.${TUTORIAL_TARGET_PROFIL_DOCS_PERSO}`,
          title: "Documents personnelles",
          content: "Mettez à jour votre RIB, CV, passeport ou titre de séjour en cas de besoin",
          disableBeacon: true,
     },
     {
          target: `.${TUTORIAL_TARGET_PROFIL_DOCS_PRO}`,
          title: "Documents professionnelles",
          content: "Accédez à vos ordres de mission, contrats et documents liés à votre embauche.",
          disableBeacon: true,
     },
     {
          target: `.${TUTORIAL_TARGET_PROFIL_TAB_SETTINGS}`,
          title: "Paramètres du compte",
          content: "En cas de besoin, changez votre mot de passe, votre adresse mail et activez le double facteur d'authentification pour plus de sécurité",
          disableBeacon: true,
     },
]
